import { h } from 'preact';
import { useEffect, useState } from 'preact/hooks';
import queryString from 'query-string'
import loadable from '@loadable/component';
import Controls from '../controls';
import sliderConfigs from '../controls/sliderConfigs';
import DownloadButton from '../downloadButton';

const Canvas = loadable(() => import('../canvas'));

const firstColors = ["#ed625d","#42b6c6","#f79f88","#b2dfe6","#03232d"]; // i've got a brand lol

const setQueryStringWithoutPageReload = qsValue => { 
	const newurl = window.location.protocol + "//" +
								 window.location.host + 
                 window.location.pathname + "?" +
								 qsValue;
	window.history.replaceState({ path: newurl }, "", newurl);
};

const Generator = ({proVersion}) => {

	const [sliderValues, setSliderValues] = useState(() => {
		const s = queryString.parse(location.search);
		const initial = {};
		sliderConfigs.forEach((c) => {
			const val = c.key;
			initial[c.key] = (typeof(s[val]) === 'undefined') ? c.default : parseFloat(s[c.key])
		});
		return initial;
	});

	const [colors, setColors] = useState(() => {
		const s = queryString.parse(location.search);		
		if (s.colors) {
			return s.colors.split("-")
		} else {
			return firstColors;
		}
	});

	const [classicMode, setClassicMode] = useState(!proVersion);	
	const [redrawFunction, setRedrawFunction] = useState(()=>()=>{});
	const [canvasRef, setCanvasRef] = useState(null);
	const [canvasSize, setCanvasSize] = useState(1000);


	const sliderValuesToSave = () => {
		const v = {};
		const slidersToShow = sliderConfigs.filter((val) => {
			return !val.proVersion || proVersion;
		});

		slidersToShow.forEach((c) => {
			v[c.key] = sliderValues[c.key];
		});
		return v;
	}

	useEffect(() => {
		const currentSettings = Object.assign({ colors: colors.join("-")} , sliderValuesToSave());
		const newSearch = queryString.stringify(currentSettings);
		setQueryStringWithoutPageReload(newSearch);
	}, [colors, sliderValues]);	

	return (
    <div class="main-container">
      <div class="canvas-container-container">
				{ (typeof window !== "undefined") && 
					<Canvas 
						colors={colors} 
						sliderValues={sliderValues}
						canvasSize={canvasSize}
						setRedrawFunction={setRedrawFunction} 
						setCanvasRef={setCanvasRef}
						classicMode={classicMode} /> }

        <button className="button-large" onClick={redrawFunction}>another</button>
        <DownloadButton canvasRef={canvasRef} />

      </div>

      <div id="ui-container">
        <Controls 
          colors={colors}
          setColors={setColors}
					sliderValues={sliderValues}
					setSliderValues={setSliderValues}
					proVersion={proVersion}
					classicMode={classicMode}
					setClassicMode={setClassicMode}
					canvasSize={canvasSize}
					setCanvasSize={setCanvasSize}
				/>
      </div>
    </div>
	);
}

export default Generator;
